const initialFormDataContact = {
  documentType: "",
  documentNumber: "",
  firstName: "",
  lastName: "",
  street: "",
  streetNumber: "",
  province: "",
  city: "",
  country: "",
  email: "",
  phone: "",
  car: "",
  carYear: "",
  consultationType: "",
  domain: "",
  mileage: "",
  vinNumber: "",
  contactedDealer: null,
  dealer: "",
  comments: "",
};

const initialFormDataTestDrive = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  street: "",
  streetNumber: "",
  province: "",
  city: "",
  country: "",
  comments: "",
};

const initialFormDataPromociones = {
  car: 24,
  firstName: "",
  lastName: "",
  documentNumber: "",
  contactPreference: "",
  email: "",
  phone: "",
  province: "",
  dealer: "",
};

export {
  initialFormDataContact,
  initialFormDataTestDrive,
  initialFormDataPromociones,
};
